export const baseInfo = {
  orgId: '', // 提供方id
  orgName: '',
  educationBureauId: '', // 提供方所属教育局id
  courseName: '', // 课程资源名称
  // termId: '', // 学期id
  courseType: [], // 课程分类
  trainingType: '', // 一级分类
  courseTypeId: '', // 课程分类id（三级分类）
  courseLevel: '', // 课程级别
  gradeGroup: '',
  gradeMin: '',
  gradeMax: '',
  studentSuggestGroup: false,
  studentSuggestMin: null, //
  studentSuggestMax: null,
  termCode: '',
  yearCode: ''
};

export const courseDetailInfo = {
  courseCoverShow: null, // 课程封面展示
  courseCover: '', // 课程封面
  courseDescribe: '', // 课程介绍
  courseAchievementShow: [], // 成果展示
  courseAchievement: '', // 成果展示
  coursePriceShow: '', // 页面展示的校内单价
  coursePrice: '', // 校内单价(页面展示的校内单价*100)
  outCoursePriceShow: '', // 页面展示的校外单价
  outCoursePrice: '' // 校外单价(页面展示的校外单价*100)
};

export const materialInfo = {
  attachmentPriceShow: '', // 材料费用展示
  attachmentPrice: '', // 材料费用
  attachmentDescribe: '' // 材料名称
};

export const otherInfo = {
  costFileLst: '', // 成本测量表id
  costFileLstShow: null // 成本测量表全链接{fileUrl:'',fileName:''}
};

export const courseTypeList = [
  {
    value: '1',
    label: '素质课程',
    loading: false,
    tag: 'first',
    children: []
  },
  {
    value: '2',
    label: '托管',
    loading: false,
    tag: 'first',
    children: []
  }
];
